import React, { useEffect, useState } from 'react';
import { Typography, Form, Input, Row, Col } from 'antd';
import { useMutation, useQuery } from '@apollo/client';
import { LeftCircleOutlined } from '@ant-design/icons';
import { Link, useNavigate } from 'react-router-dom';
import Select from 'react-select';
import { PrimaryButton } from '../components';
import { GET_USERS, SEND_MESSAGE, GET_CHANNELS } from '../graphql';
import { IUser } from '../interfaces';
import { successMessage } from '../utils/Notifications';
import { getID } from '../services';

const { Title, Text } = Typography;
const FormItem = Form.Item;

type FormData = {
    to: string;
    text: string;
};

type SelectOptions = {
    value: string;
    label: string;
};

export type ProfileProps = {
    isAdmin: boolean;
};

function ComposeMessage({ isAdmin }: ProfileProps): JSX.Element {
    const navigate = useNavigate();
    const [users, setUsers] = useState<SelectOptions[]>([{value:'', label:'empty'}]);
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const { loading: usersLoading, data } = useQuery(GET_USERS, {
        variables: {},
        fetchPolicy: 'network-only',
    });
    const [sendMessageMutation, { loading: sendingMessage }] = useMutation(SEND_MESSAGE);
    const [to, setTo] = useState<string | null>(null);
    const handleChange = (selectedOption: any) => {
        setTo(selectedOption.value);
    };

    useEffect(() => {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        if (data?.getUsers?.users) {
            let allUsers: IUser[];
            if(isAdmin){
             // eslint-disable-next-line @typescript-eslint/no-unsafe-call
             allUsers = Array.isArray(data?.getUsers?.users) ? data.getUsers.users.filter((user: { id: string }) => user.id !== getID()) : [];
            }else{
             // eslint-disable-next-line @typescript-eslint/no-unsafe-call
             allUsers =  [
                {
                    "id": "f7b326e0-2b2d-11ee-9255-7b838140fae3",
                    "firstName": "ReveNewCycle",
                    "lastName": "Support",
                    "email": "admin@revenewcycle.com",
                    "phone": "+12345678910",
                    "roleId": "ADMIN",
                    "photo": ""
                }];

             // Array.isArray(data?.getUsers?.users) ? data.getUsers.users.filter((user: { id: string, roleId: string }) => user.id !== getID() && user.roleId !== 'CLIENT') : [];
            }
            const options: SelectOptions[] = allUsers.map((user: IUser) => ({
                value: String(user.id),
                label: `${user.firstName} ${user.lastName} (${user.email})`
            }));
            setUsers(options);
        }
    }, [data]);

    const sendMessage = (formData: FormData) => {
        const { text } = formData;
        sendMessageMutation({
            variables: { to, text },
            refetchQueries: [{ query: GET_CHANNELS, variables: { count: 50, status: 'SENT' } }],
        })
            .then(() => {
                successMessage('Message sent successfully');
                navigate(-1);
            })
            .catch((err) => {
                console.log(err);
            });
    };

    return (
        <div style={{ width: '100%', background: '#fff', borderRadius: '15px' }}>
            <Row className="margin-bottom-lg" style={{ paddingTop: '10px' }}>
                <Col span="12" style={{ textAlign: 'left', paddingLeft: '10px' }}>
                    {' '}
                    <Title level={3} style={{ fontSize: '15px' }}>
                        Compose Message
                    </Title>{' '}
                </Col>
                <Col span="12" style={{ textAlign: 'right', paddingRight: '10px' }}>
                    <Link to="/messages">
                        <Text style={{ fontSize: '18px' }}>
                            <LeftCircleOutlined />
                            &nbsp;Back
                        </Text>
                    </Link>
                </Col>
            </Row>

            <Row className="margin-bottom-lg">
                <Col span="24" style={{ padding: '5px' }}>
                    <Form onFinish={sendMessage}>
                        <FormItem name="to">
                            <div style={{ width: '40%' }}>
                                {/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */}
                                <Select
                                    onChange={handleChange}
                                    options={users}
                                    placeholder="Select a User"
                                />
                            </div>
                        </FormItem>
                        <FormItem name="text">
                            <Input.TextArea
                                rows={12}
                                style={{ borderWidth: '1px', borderColor: '#cccccc', borderRadius: '5px' }}
                                placeholder="Enter your message"
                            />
                        </FormItem>
                        <div className="float-right">
                            <PrimaryButton title="Send" htmlType="submit" loading={sendingMessage} />
                        </div>
                    </Form>
                </Col>
            </Row>
        </div>
    );
}

export default ComposeMessage;
